// removed by extract-text-webpack-plugin
module.exports = {"container":"yNXilyPB5MH145dIahIUV","buttonCustomStyle":"_2BYlkw4dTkXI60lBc-4z_8","buttonContainer":"hltTdljf7CXbdxtWpGVRL","buttonWrapper":"_1OGIUoBrVgqr_ISngGdA3n","customButton":"_2FrgOl2ZFr1QL7EXogD98t"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/demoplayNotificationScreen.css
// module id = 904
// module chunks = 0